export const baseURL = 'https://dkycapi.ongrid.in/'